export enum SMSActionType {
  SET_SMS_TARGET = "SET_SMS_TARGET",
  SET_SMS_USERS = "SET_SMS_USERS",
  SET_USER_MESSAGE = "SET_USER_MESSAGE",
  SET_READ_SMS = "SET_READ_SMS",
  SET_ACTIVE_SMS = "SET_ACTIVE_SMS",
  CLEAR_SMS_STORE = "CLEAR_SMS_STORE",
  SET_PREVIOUS_MESSAGE = "SET_PREVIOUS_MESSAGE",
}
